import React, { useRef, useEffect } from "react";

export default function OTPInput({ length = 6, value = "", onChange, disabled = false }) {
  const inputRefs = useRef([]);

  // Ensure value array length matches
  const otpArray = Array.from({ length }, (_, i) => value[i] || "");

  useEffect(() => {
    // Focus first input on mount if empty
    if (!value && inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (e, index) => {
    const val = e.target.value;
    // Only accept numeric digits
    if (!/^\d*$/.test(val)) return;

    const newOtp = [...otpArray];
    // Take last entered character
    newOtp[index] = val.slice(-1);
    const combinedValue = newOtp.join("");
    onChange(combinedValue);

    // Auto-advance focus to next field if character typed
    if (val && index < length - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (!otpArray[index] && index > 0 && inputRefs.current[index - 1]) {
        // If current cell is empty, clear previous cell and move focus back
        const newOtp = [...otpArray];
        newOtp[index - 1] = "";
        onChange(newOtp.join(""));
        inputRefs.current[index - 1].focus();
      }
    } else if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (e.key === "ArrowRight" && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    // Extract only digits up to length
    const digitsOnly = pastedData.replace(/\D/g, "").slice(0, length);
    if (!digitsOnly) return;

    onChange(digitsOnly);

    const focusIndex = Math.min(digitsOnly.length, length - 1);
    if (inputRefs.current[focusIndex]) {
      inputRefs.current[focusIndex].focus();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        justifyContent: "center",
        margin: "20px 0",
      }}
    >
      {Array.from({ length }).map((_, index) => (
        <input
          key={index}
          ref={(el) => (inputRefs.current[index] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={otpArray[index]}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onPaste={handlePaste}
          disabled={disabled}
          style={{
            width: "48px",
            height: "54px",
            textAlign: "center",
            fontSize: "22px",
            fontWeight: "600",
            borderRadius: "8px",
            border: otpArray[index] ? "2px solid #5e3bee" : "1px solid #ced4da",
            backgroundColor: disabled ? "#e9ecef" : "#ffffff",
            color: "#212529",
            outline: "none",
            transition: "border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#5e3bee";
            e.target.style.boxShadow = "0 0 0 3px rgba(94, 59, 238, 0.25)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = otpArray[index] ? "#5e3bee" : "#ced4da";
            e.target.style.boxShadow = "none";
          }}
        />
      ))}
    </div>
  );
}
